(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-totals"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const wrapper = document.querySelector('[data-section-type="cart-totals"]');
    if (!wrapper) return;

    // 防止重複初始化
    const FLAG = wrapper.dataset.initFlag;
    if (window[FLAG]) return;
    window[FLAG] = true;

    const sid = wrapper.dataset.sectionId;
    const contentId = wrapper.dataset.contentId;

    // 小工具：每次都取最新的 content 容器
    const getContentEl = () => document.getElementById(contentId);

    // 去抖：把頻繁的事件合併
    let tmr;
    const debounce = (fn, delay = 180) => {
      clearTimeout(tmr);
      tmr = setTimeout(fn, delay);
    };

    // 用 routes.root 支援多語系/子路徑
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    function htmlToNode(html) {
      const dom = new DOMParser().parseFromString(html, 'text/html');
      return dom.getElementById(contentId);
    }

    function refreshTotals() {
      // 先試新版 ?sections=
      const u1 = new URL(window.location.href);
      u1.pathname = root.replace(/\/$/, '') + u1.pathname.replace(root.replace(/\/$/, ''), '');
      u1.searchParams.set('sections', sid);

      fetch(u1.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(r => r.ok ? r.json() : Promise.reject())
        .then(json => {
          const html = json && json[sid];
          if (!html) throw new Error('Sections JSON missing');
          const freshContent = htmlToNode(html);
          const contentEl = getContentEl();
          if (freshContent && contentEl) {
            contentEl.replaceWith(freshContent);
          }
        })
        .catch(() => {
          // 舊法 fallback: ?section_id=
          const u2 = new URL(window.location.href);
          u2.pathname = root.replace(/\/$/, '') + u2.pathname.replace(root.replace(/\/$/, ''), '');
          u2.searchParams.set('section_id', sid);

          fetch(u2.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(r => r.text())
            .then(html => {
              const freshContent = htmlToNode(html);
              const contentEl = getContentEl();
              if (freshContent && contentEl) {
                contentEl.replaceWith(freshContent);
              }
            })
            .catch(() => {
              console.error('Failed to refresh totals');
            });
        });
    }

    // —— A: 主題/外掛可能丟的事件 —— //
    [
      'cart:updated','cart:change','cart:refresh','quantity:change',
      'product:added','cart:item:added','cart:item:updated','cart:item:removed'
    ].forEach(evt => document.addEventListener(evt, () => debounce(() => refreshTotals(), 240)));

    // —— B: 攔截 cart 相關的 fetch / XHR —— //
    const _fetch = window.fetch;
    window.fetch = function(...args){
      return _fetch.apply(this, args).then(res => {
        try {
          const u = String(args[0]||'');
          if (u.includes('/cart') || u.includes('/add') || u.includes('cart/add')) {
            debounce(() => refreshTotals(), 260);
          }
        } catch(e){}
        return res;
      });
    };

    const _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(m, u, ...rest) {
      this.addEventListener('load', function(){
        try {
          const s = String(u||'');
          if (s.includes('/cart') || s.includes('/add') || s.includes('cart/add')) {
            debounce(() => refreshTotals(), 260);
          }
        } catch(e){}
      });
      return _open.apply(this, [m, u, ...rest]);
    };

    // —— C: 鏡像原生 summary（你是隱藏不是移除） —— //
    const nativeTotal = document.querySelector(
      '.cart-page__summary [data-cart-subtotal], .cart-page__summary .cart__total .cart__total-value'
    );
    if (nativeTotal) {
      const sync = () => {
        const mine = document.querySelector('#' + contentId + ' [data-cart-subtotal]');
        if (!mine) return;
        const t = (nativeTotal.textContent||'').trim();
        if (t && t !== (mine.textContent||'').trim()) {
          mine.textContent = t;
          mine.setAttribute('value', t);
        }
      };
      const mo = new MutationObserver(sync);
      mo.observe(nativeTotal, { characterData:true, childList:true, subtree:true });
      sync();
    }

    // 初始化先跑一次（給首次進頁或快取）
    document.addEventListener('DOMContentLoaded', () => refreshTotals());
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
